// extracted by mini-css-extract-plugin
export var createdDate = "_iw-1";
export var divider = "_iw-2";
export var headerDivider = "_iw-3";
export var messagesCard = "_iw-0";
export var messagesContainer = "_iw-7";
export var messagesContainerWrapper = "_iw-4";
export var pointerCapturingButtonBoxes = "_iw-a";
export var showLeftPanelButton = "_iw-9";
export var showMoreButton = "_iw-c";
export var showMoreButtonContainer = "_iw-b";
export var summaryTitle = "_iw-6";
export var systemMessageCardWrapper = "_iw-d";
export var topButtons = "_iw-8";
export var withPadding = "_iw-5";